<template>
  <v-app>
    <AppNavigation v-if="!isLoginPage" />
    
    <v-main>
      <router-view />
    </v-main>

    <AppFooter v-if="!isLoginPage" />
  </v-app>
</template>

<script>
import AppNavigation from '@/components/AppNavigation.vue'
import AppFooter from '@/components/AppFooter.vue'

export default {
  name: 'App',
  components: {
    AppNavigation,
    AppFooter
  },
  computed: {
    isLoginPage() {
      return this.$route.path === '/login'
    }
  }
}
</script>

<style>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700;800&family=Montserrat:wght@300;400;500;600;700;800&display=swap');

/* Global Styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: 'Montserrat', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
}

/* Vuetify Overrides */
.v-application {
  font-family: 'Montserrat', sans-serif !important;
}

.v-application .headline,
.v-application .title,
.v-application .display-1,
.v-application .display-2,
.v-application .display-3,
.v-application .display-4 {
  font-family: 'Playfair Display', serif !important;
}

/* Custom Scrollbar */
::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: #f8f6f1;
}

::-webkit-scrollbar-thumb {
  background: #d4af37;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
  background: #b8963c;
}

/* Selection Color */
::selection {
  background-color: rgba(212, 175, 55, 0.3);
  color: #2d4a3e;
}

::-moz-selection {
  background-color: rgba(212, 175, 55, 0.3);
  color: #2d4a3e;
}

/* Smooth Transitions */
a {
  transition: all 0.3s ease;
}

/* Utility Classes */
.text-gold {
  color: #d4af37 !important;
}

.bg-gold {
  background-color: #d4af37 !important;
}

.text-primary-dark {
  color: #2d4a3e !important;
}

.bg-primary-dark {
  background-color: #2d4a3e !important;
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-in {
  animation: fadeIn 0.6s ease-out;
}

/* Remove default focus outline and add custom */
*:focus {
  outline: none;
}

button:focus,
a:focus,
input:focus,
textarea:focus,
select:focus {
  outline: 2px solid rgba(212, 175, 55, 0.5);
  outline-offset: 2px;
}
</style>